import type { VillageViewModel } from "../../domain/contracts";

export function buildReferenceFactRows(village: VillageViewModel | null): Array<{ label: string; value: string }> {
  if (!village) {
    return [];
  }

  const rows = [
    { label: "Village", value: village.title },
    { label: "Myanmar name", value: village.reference?.myanmarName ?? "" },
    { label: "Township", value: village.township },
    { label: "Coordinates", value: formatCoordinates(village.coordinates.lat, village.coordinates.lng) },
    { label: "Published", value: village.reference?.published ?? village.publishVersion },
    { label: "Added", value: formatDateValue(village.reference?.dateAdded ?? "") },
    { label: "Status 2019", value: village.reference?.status2019 ?? "" },
    { label: "Status 2017", value: village.reference?.status2017 ?? "" },
    { label: "Reconstruction", value: village.reference?.reconstruction ?? "" },
    { label: "Reconstruction type", value: village.reference?.reconstructionType ?? "" },
  ];

  return rows.filter((row) => hasDisplayValue(row.value));
}

export function humanizeStatus(value: string | null | undefined): string {
  const normalized = typeof value === "string"
    ? value.trim().replace(/[_-]+/g, " ").replace(/\s+/g, " ")
    : "";

  if (!normalized) {
    return "Unknown";
  }

  return normalized
    .toLowerCase()
    .replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
}

function formatCoordinates(lat: number, lng: number): string {
  if (lat === 0 && lng === 0) {
    return "";
  }

  return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
}

function formatDateValue(value: string): string {
  if (!value) {
    return "";
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

function hasDisplayValue(value: string | null | undefined): value is string {
  if (!value) {
    return false;
  }

  const normalized = value.trim();
  if (!normalized) {
    return false;
  }

  return normalized !== "-" && normalized.toLowerCase() !== "unknown" && normalized.toLowerCase() !== "n/a";
}
